import { Box, Card, Grid, Modal, Typography, TextField } from "@mui/material";
import MDButton from "components/MDButton";

import PersonOffIcon from "@mui/icons-material/PersonOff";
import { useState } from "react";
import { showResMsg } from "utils/generic";
import { useMaterialUIController } from "context";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  p: 4,
  display: "grid",
  justifyContent: "center",
};

function ConfirmPasswordModal({ ...props }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const [values, setValues] = useState({
    password: "",
    reasonValue: "",
  });
  const handleChange = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value });
  };

  const handleConfirm = () => {
    if (!values.password) {
      showResMsg(`Password can't be blank.`, 1000, false);
    } else if (!values.reasonValue) {
      showResMsg(`Reason can't be blank.`, 1000, false);
    } else {
      props.handleConfirmDeactivate(
        values.password,
        values.reasonValue,
        props.action
      );
      setValues({ ...values, password: "", reasonValue: "" });
    }
  };

  return (
    <Modal
      open={props.open}
      onClose={props.handleClose}
      disableEscapeKeyDown
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Card sx={style} className={darkMode ? "dark" : "light"}>
        <Box>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            style={{ fontSize: "40px", textAlign: "center" }}
          >
            <PersonOffIcon style={{ color: "#FB8C00" }} />
          </Typography>
          <Typography
            className={darkMode ? "dark-modes" : "light-modes"}
            id="modal-modal-title"
            variant="h6"
            component="h2"
            style={{ color: "black", textAlign: "center" }}
          >
            {props.title ? props.title : "Confirm Account Deactivation"}
          </Typography>
          <Typography
            id="modal-modal-description"
            sx={{ mt: 2, fontSize: 12, textAlign: "center" }}
          >
            {props.message
              ? props.message
              : `Please enter your password and the reason for deactivating your account below to confirm your request.`}
          </Typography>

          <TextField
            label="Password"
            type="password"
            value={values.password}
            autoComplete="new-password"
            onChange={handleChange("password")}
            fullWidth
            sx={{ mt: 2 }}
          />

          <TextField
            label="Reason to Deactivate"
            value={values.reasonValue}
            onChange={handleChange("reasonValue")}
            fullWidth
            multiline
            rows={2}
            autoComplete="new-reason"
            sx={{ mt: 2 }}
          />

          <Grid
            container
            id="modal-modal-description"
            sx={{ mt: 2, justifyContent: "center" }}
          >
            <MDButton
              className="modalButton no-button"
              onClick={props.handleClose}
              style={{ width: "64px", textTransform: "capitalize" }}
            >
              Cancel
            </MDButton>
            &nbsp; &nbsp;
            <MDButton
              className="modalButton yes-button"
              onClick={handleConfirm}
              style={{ width: "64px", textTransform: "capitalize" }}
            >
              Confirm
            </MDButton>
          </Grid>
        </Box>
      </Card>
    </Modal>
  );
}

export default ConfirmPasswordModal;
